import {RootStore} from '../index';
import {action, makeAutoObservable} from "mobx"
import ArrayFc from "../../helper/ArrayFc";
import {HelperLetter} from "../../helper/helperLetter";
import BlockPropertyModel from "../../model/BlockPropertyModel";
import ElementModel from "../../model/ElementModel";


export class ComFilterCatalogStore {
    private rootStore: RootStore | undefined;

    private separator = '+';
    letterBrandChecked: string[] = [];
    letterBrandRu: string[] = [];
    letterBrandEn: string[] = [];
    arBrand = [];
    arBrandShow = [];
    arBrandChecked: number[] = [];
    activeLang = 'en';

    isShowBrand = true;
    isFilterVisible = true;

    isNoveltyFilter = false;
    isSelloutFilter = false;
    isSaleFilter = false;
    isLoyaltyFilter = false;



    filter = {};

    letterKindChecked: string[] = [];
    letterKindRu: string[] = [];
    letterKindEn: string[] = [];
    arKind = [];
    arKindShow = [];
    arKindChecked: number[] = [];
    clientId: number | undefined = 0


    isNoveltyFilterShow = true;
    isSelloutFilterShow = true;
    isSaleFilterShow = true;

    public error: string = '';

    pagination = {
        countPage: 1,
        countRow: 1,
        currentPage: 1
    }
    constructor(rootStore?: RootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    init(filter: string | undefined) {
        this.resetShowFilter();
        this.initFilter(filter);
        this.setFilter();
        this.arBrand = [];
        this.arKind = [];
        // alert(filter)
        // if (filter?.includes("brand-in-")){
        //     // @ts-ignore
        //     // window.history.pushState(null, null, "/brands");
        //     alert('33')
        // }else{
        
        let token = localStorage.getItem("token");
        // alert(token)
        
        // Если токен есть в localStorage, но его нет в API instance, обновляем API
        if (token && !BlockPropertyModel.q.token) {
            BlockPropertyModel.q.setBaseUrl();
            BlockPropertyModel.q.reload();
        }
        
        BlockPropertyModel.getBrand(this.filter,
                this.setBrands, this.setError
            );
            BlockPropertyModel.getItemType(this.filter,
                this.setKind, this.setError
            );
    // }

    }


    @action
    resetShowFilter = () => {
        this.isNoveltyFilter = false;
        this.isSelloutFilter = false;
        this.isSaleFilter = false;
        this.isShowBrand = true;
        this.isLoyaltyFilter = false;
        this.isFilterVisible = true;
        this.resetFilterChecked();
    }

    getBrands  ()  {

        let page = 0
        if (this.pagination === undefined) {
            page = 1;
        }else {
           page = this.pagination.currentPage
        }
        this.clientId = this.rootStore?.mainStore.getClientId()
        if (this.clientId ){
            ElementModel.getBrands({
                json: {
                    clientId: this.clientId,
                    filter: this.filter,
                    limit: 32,
                },
                page: page
            }, this.setBrands, this.setError);

        }
    }
    onCurrentPage = (page: number) => {
        this.pagination.currentPage = page;
        this.getBrands();
    }

    @action
    resetFilterChecked = () => {
        this.arBrandShow = [];
        this.arKindShow = [];

        this.letterBrandChecked = [];
        this.letterKindChecked = [];

        this.arBrandChecked = [];
        this.arKindChecked = [];
    }

    @action
    setFilter() {
        let filter = this.rootStore?.pageCatalogStore.SetSection({});
        // @ts-ignore
        this.filter = {clientId: this.rootStore?.mainStore.getClientId(), filter: filter}
    }

    public SetCheckbox(filter: any) {

        if (this.isSelloutFilter || this.isSaleFilter || this.isSelloutFilter || this.isLoyaltyFilter) {
            filter['props'] = {};
        }

        if (this.isNoveltyFilter) {
            filter['props'] = {...filter['props'], isNovelty: true}
        }
        if (this.isSaleFilter) {
            filter['props'] = {...filter['props'], isSale: true}
        }
        if (this.isSelloutFilter) {
            filter['props'] = {...filter['props'], isSellout: true}
        }
        if (this.isLoyaltyFilter) {
            filter['props'] = {...filter['props'], isIncludeLoyaltyProgram: true}
        }
        return filter;
    }

    @action setBrands = (result: any) => {
        this.pagination = result.data.pagination;
        this.arBrand = result.data.enum;
        this.setLetterBrand(result.data.enum);
        
        // Уведомляем PageCatalogStore о том, что бренды загружены
        this.rootStore?.pageCatalogStore.processUrlFilterAfterBrandsLoaded();
    }

    @action setKind = (result: any) => {
        this.arKind = result.data.enum;
        this.setLetterKind(result.data.enum);
    }

    @action setLetterBrand(arBrand: any[]) {
        let letter: string[] = [];
        arBrand.map(item => {
            // @ts-ignore
            if (item.value !== undefined && item.value.length) {
                let uc = item.value.substr(0, 1).toUpperCase();
                // @ts-ignore
                letter.push(uc);
                if (
                    this.arBrandChecked.length &&
                    this.arBrandChecked.indexOf(parseInt(item.id)) !== -1 &&
                    this.letterBrandChecked.indexOf(uc) === -1) {
                    this.letterBrandChecked.push(uc);
                }
            }
            return item;
        });

        letter = ArrayFc.uniqFast(letter);

        if (this.letterBrandChecked.length) {
            this.brandShow();
        }

        this.letterBrandRu = this.setLetterRu(letter);
        this.letterBrandEn = this.setLetterEn(letter);
    }

    @action setLetterKind(arKind: any[]) {
        let letter: string[] = [];
        arKind.map(item => {
            // @ts-ignore
            if (item.value !== undefined && item.value.length) {
                let uc = item.value.substr(0, 1).toUpperCase();
                // @ts-ignore
                letter.push(uc);
                if (
                    this.arKindChecked.length &&
                    this.arKindChecked.indexOf(parseInt(item.id)) !== -1 &&
                    this.letterKindChecked.indexOf(uc) === -1
                ) {
                    this.letterKindChecked.push(uc);
                    this.isShowBrand = false;
                }
            }
            return item;
        });

        letter = ArrayFc.uniqFast(letter);

        this.letterKindRu = this.setLetterRu(letter);
        this.letterKindEn = this.setLetterEn(letter);

        if (this.letterKindChecked.length) {
            this.kindShow();
        }
    }

    setLetterRu(letter: string[]) {
        let r: string[] = [];
        for (let el of HelperLetter.num) {
            if (letter.includes(String(el))) {
                r.push(String(el));
            }
        }
        for (let el of HelperLetter.RU) {
            if (letter.includes(String(el))) {
                r.push(String(el));
            }
        }
        return r;
    }

    setLetterEn(letter: string[]) {
        let r: string[] = [];
        for (let el of HelperLetter.EN) {
            if (letter.includes(String(el))) {
                r.push(String(el));
            }
        }
        return r;
    }

    @action onLetterBrandChecked = (l: string) => {
        if (this.letterBrandChecked.includes(l)) {
            this.removeFilterLetter(l, 'Brand');
            this.letterBrandChecked.splice(this.letterBrandChecked.indexOf(l), 1);
        } else {
            this.letterBrandChecked.push(l);
        }
        this.brandShow();
    }

    brandShow=()=> {
        this.arBrandShow = [];
        this.letterBrandChecked.map((letter: string) => {
            if (this.arBrand){
                this.arBrand.map((item => {
                    // @ts-ignore
                    if (item.value.substr(0, 1).toUpperCase() === letter) {
                        this.arBrandShow.push(item);
                    }
                    return item;
                }))
            }



            return letter;
        });
    }

    onBrandChecked = (id: number) => {
        if (this.arBrandChecked.includes(id)) {
            this.arBrandChecked.splice(this.arBrandChecked.indexOf(id), 1);
        } else {
            this.arBrandChecked.push(id);
        }
        this.rootStore?.pageCatalogStore.reload(true);
    }


    @action onShowBrandOn = () => {
        this.resetFilterChecked();
        this.isShowBrand = true;
        this.rootStore?.pageCatalogStore.reload(true);
    }

    @action onShowBrandOff = () => {
        this.resetFilterChecked();
        this.isShowBrand = false;
        this.rootStore?.pageCatalogStore.reload(true);
    }


    @action onLetterKindChecked = (l: string) => {
        if (this.letterKindChecked.includes(l)) {
            this.removeFilterLetter(l, 'Kind');
            this.letterKindChecked.splice(this.letterKindChecked.indexOf(l), 1);
        } else {
            this.letterKindChecked.push(l);
        }
        this.kindShow();
    }

    kindShow() {
        this.arKindShow = [];
        this.letterKindChecked.map((letter: string) => {
            this.arKind.map((item => {
                // @ts-ignore
                if (item.value.substr(0, 1).toUpperCase() === letter) {
                    this.arKindShow.push(item);
                }
                return item;
            }))
            return letter;
        });
    }

    onKindChecked = (id: number) => {
        if (this.arKindChecked.includes(id)) {
            this.arKindChecked.splice(this.arKindChecked.indexOf(id), 1);
        } else {
            this.arKindChecked.push(id);
        }
        this.rootStore?.pageCatalogStore.reload(true);
    }


    onNoveltyFilter = () => {
        this.isNoveltyFilter = !this.isNoveltyFilter;
        this.rootStore?.pageCatalogStore.reload(true);
    }

    onSelloutFilter = () => {
        this.isSelloutFilter = !this.isSelloutFilter;
        this.rootStore?.pageCatalogStore.reload(true);
    }

    onSaleFilter = () => {
        this.isSaleFilter = !this.isSaleFilter;
        this.rootStore?.pageCatalogStore.reload(true);
    }

    @action
    setError = (error: any) => {
        // if (window.location.pathname.indexOf("/catalog/filter/brand-in-") > -1){
        //     // @ts-ignore
        //     window.history.pushState(null, null, "/brands");
        //     alert('33')
        // };

        console.log(error)
        // this.error = error.response.data.message;
    }

    private initFilter(sFilter: string | undefined) {
        if (sFilter !== undefined) {
            let arFilter = sFilter.split(this.separator);
            for (let f of arFilter) {
                if (f.indexOf('-is-') >= 0) {
                    let arProp = f.split('-is-');
                    this.setFilterProps(arProp[0], arProp[1]);
                } else if (f.indexOf('-in-')) {
                    let arProp = f.split('-in-');
                    switch (arProp[0]) {
                        case 'brand':
                            arProp[1].split(',').map(n => {
                                this.arBrandChecked.push(parseInt(n));
                                return n;
                            });
                            break;
                        case 'itemType':
                            arProp[1].split(',').map(n => {
                                this.arKindChecked.push(parseInt(n));
                                return n;
                            });
                            break;
                    }
                }
            }
        }
    }


    setFilterUrl() {
        return this.setFilterString();
    }

    setFilterString() {
        let arS = [];
        const {
            arBrandChecked,
            arKindChecked,
            isNoveltyFilter,
            isSelloutFilter,
            isSaleFilter,
            isLoyaltyFilter
        } = this;

        if (arBrandChecked.length) {
            arS.push('brand' + '-in-' + arBrandChecked.join(','));
        }

        if (arKindChecked.length) {
            arS.push('itemType' + '-in-' + arKindChecked.join(','));
        }

        if (isNoveltyFilter) {
            arS.push('isNovelty-is-true');
        }
        if (isSelloutFilter) {
            arS.push('isSellout-is-true');
        }
        if (isSaleFilter) {
            arS.push('isSale-is-true');
        }
        if (isLoyaltyFilter) {
            arS.push('isIncludeLoyaltyProgram-is-true');
        }
        return arS.length ? arS.join('+') : '';
    }

    @action
    setFilterProps(code: string, value: string) {
        switch (code) {
            case 'isNovelty':
                this.isNoveltyFilter = true;
                break;
            case 'isSellout':
                this.isSelloutFilter = true;
                break;
            case 'isSale':
                this.isSaleFilter = true;
                break;
            case 'isIncludeLoyaltyProgram':
                this.isLoyaltyFilter = true;
                break;
        }
    }


    removeFilterWorld = (l: string, keyShow: string, keyChecked: string) => {
        let arId: any[] = [];
        // @ts-ignore
        this[keyShow].forEach((item: any) => {
            let uc = item.value.substr(0, 1).toUpperCase();
            // @ts-ignore
            if (uc === l && this[keyChecked].includes(item.id)) {
                arId.push(item.id);
            }
        });
        if (arId.length) {
            arId.forEach((id: number,) => {
                // @ts-ignore
                let index = this[keyChecked].indexOf(id);
                // @ts-ignore
                this[keyChecked].splice(index, 1);
            });
        }
        if (arId.length) {
            this.rootStore?.pageCatalogStore.reload(true);
        }
    }


    private removeFilterLetter(l: string, n: string) {
        if (n === 'Brand') {
            this.removeFilterWorld(l, 'arBrandShow', 'arBrandChecked');
        }
        if (n === 'Kind') {
            this.removeFilterWorld(l, 'arKindShow', 'arKindChecked');
        }
    }

    @action onActiveLang = (l: string) => {
        this.activeLang = l;
    }

    @action
    toggleFilterVisibility = () => {
        this.isFilterVisible = !this.isFilterVisible;
    }
}